/**
 * What the net client needs from its host, injected so the same code runs in browsers, Bun and Node,
 * and tests can drive time and sockets by hand. (This package is compiled without DOM types.)
 */
export interface SocketLike {
  binaryType: string;
  readonly readyState: number;
  onopen: ((ev: unknown) => void) | null;
  onclose: ((ev: { code: number }) => void) | null;
  onerror: ((ev: unknown) => void) | null;
  onmessage: ((ev: { data: unknown }) => void) | null;
  send(data: Uint8Array): void;
  close(code?: number, reason?: string): void;
}
export type SocketFactory = (url: string) => SocketLike;

export interface Env {
  now(): number;
  setTimeout(fn: () => void, ms: number): unknown;
  clearTimeout(handle: unknown): void;
  random(): number;
  socket: SocketFactory;
}

export const OPEN = 1;

type Host = {
  performance: { now(): number };
  setTimeout(fn: () => void, ms: number): unknown;
  clearTimeout(h: unknown): void;
  WebSocket: new (url: string) => SocketLike;
};

export function hostEnv(): Env {
  const g = globalThis as unknown as Host;
  return {
    now: () => g.performance.now(),
    setTimeout: (fn, ms) => g.setTimeout(fn, ms),
    clearTimeout: (h) => g.clearTimeout(h),
    // backoff jitter only: never part of the simulation
    random: () => Math.random(),
    socket: (url) => new g.WebSocket(url),
  };
}
